import React from 'react';
type Tone = 'navy' | 'green' | 'orange' | 'light';
interface CategoryTagProps {
  label: string;
  tone?: Tone;
  className?: string;
}
const tones: Record<Tone, string> = {
  navy: 'border-ville-navy/25 text-ville-navy',
  green: 'border-ville-leaf text-ville-deep',
  orange: 'border-ville-lime text-ville-lime',
  light: 'border-white/40 text-white'
};

/** Pastille de catégorie bordée, en capitales — actualités, événements, cartes. */
export function CategoryTag({
  label,
  tone = 'navy',
  className = ''
}: CategoryTagProps) {
  return <span className={`inline-block rounded-full border px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] ${tones[tone]} ${className}`} data-id="element-2858" data-mp="3gcuuz465pofv">
      {label}
    </span>;
}